import api from './axios';
import {
    Payment,
    CreatePaymentRequest,
    UpdatePaymentRequest
} from '../types/payment';

export async function getPayments(fiscalYear: number): Promise<Payment[]> {
    const res = await api.get<Payment[]>('/payments', { params: { fiscalYear } });
    return res.data;
}

export async function createPayment(
    data: CreatePaymentRequest
): Promise<Payment> {
    const res = await api.post<Payment>('/payments', data);
    return res.data;
}

export async function updatePayment(
    id: string,
    data: UpdatePaymentRequest
): Promise<Payment> {
    const res = await api.patch<Payment>(`/payments/${id}`, data);
    return res.data;
}

export async function deletePayment(id: string): Promise<void> {
    await api.delete(`/payments/${id}`);
}
